module.exports = __webpack_public_path__ + "static/media/0002.3ac8337e.jpg";